<template>
  <div>
    <NavigationBreadcrumb
      :items="breadcrumb_items"
      :baseMatterId="matter_id"
      :showInstructional="true"
    ></NavigationBreadcrumb>
    <h4 class="mt-3">
      {{
        $getVisibleNames(
          "manual.matter_program",
          false,
          "Programa de la Asignatura"
        ).toUpperCase()
      }}
      <button-edit
        v-can="'teaching.change_matter'"
        v-if="oldMatter && allows_crud && can_update"
        @click="$bvModal.show(`modal-edit-matter-${oldMatter.id}`)"
        v-b-tooltip.v-secondary.noninteractive="
          `${$t('reusable.common.edit')} ${$getVisibleNames(
            'mesh.egressprofilematter',
            false,
            'Asignatura'
          )}`
        "
      ></button-edit>
    </h4>
    <b-modal
      v-if="oldMatter"
      :id="`modal-edit-matter-${oldMatter.id}`"
      hide-footer
      :title="`${$t('reusable.common.edit')} ${$getVisibleNames(
        'teaching.matter',
        false,
        'Asignatura Base'
      )}`"
      size="lg"
    >
      <OldMatterForm
        :OldMatter="oldMatter"
        @updated="$bvModal.hide(`modal-edit-matter-${oldMatter.id}`)"
        :show_delete_button="false"
      >
      </OldMatterForm>
    </b-modal>
    <NewMatterPresentation
      v-if="oldMatter"
      :oldMatter="oldMatter"
    ></NewMatterPresentation>
    <MatterProgramDescriptors
      :page_position="1"
      :matter_id="matter_id"
      :descriptor_titles="egressProfileMatterDescriptor"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_delete="can_delete"
      :can_update="can_update"
      :can_delete_title="canDeleteTitle"
      @titleCreated="titleCreated"
      @deleteTitle="deleteTitle"
    ></MatterProgramDescriptors>
    <EvaluationCriteriaMacroComponent
      v-if="oldMatter"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
    ></EvaluationCriteriaMacroComponent>
    <template v-if="institution && institution.show_competence_unit">
      <b-button
        v-if="allows_crud && oldMatter && !oldMatter.is_closed && can_update"
        size="sm"
        class="secondary-button my-2"
        @click="$bvModal.show(`add-unit-competence-modal`)"
        ><b-icon-plus></b-icon-plus>{{ $t("reusable.common.add") }}
        {{
          $getVisibleNames(
            "teaching.tempcompetenceunit",
            false,
            "Unidad de competencia"
          )
        }}</b-button
      >
      <b-modal
        :id="`add-unit-competence-modal`"
        hide-footer
        :title="`${$t('reusable.common.add')} ${$getVisibleNames(
          'teaching.tempcompetenceunit',
          false,
          'Unidad de competencia'
        )}`"
        size="lg"
      >
        <CompetenceUnitForm
          v-if="oldMatter"
          :matter_id="oldMatter.id"
          @created="$bvModal.hide(`add-unit-competence-modal`)"
          @close_modal="$bvModal.hide(`add-unit-competence-modal`)"
        ></CompetenceUnitForm>
      </b-modal>
      <template v-if="oldMatter && temp_competence_units.length > 0">
        <CompetenceUnits
          v-for="temp_competence_unit in temp_competence_units"
          :key="`unit-competence-${temp_competence_unit.id}`"
          :oldMatter="oldMatter"
          :tempCompetenceUnit="temp_competence_unit"
          :allows_crud="allows_crud"
          :can_update="can_update"
          :can_delete="can_delete"
        ></CompetenceUnits>
      </template>
    </template>
    <CompetenceUnits
      v-if="oldMatter"
      :oldMatter="oldMatter"
      :tempCompetenceUnit="null"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
    ></CompetenceUnits>
    <!-- <div v-if="studyUnitsList.length > 0 && oldMatter">
      <UnitSection
        v-for="study_unit in studyUnitsList"
        :study_unit_id="study_unit.id"
        :matter_id="oldMatter.id"
        :allows_crud="allows_crud && oldMatter && !oldMatter.is_closed"
        :key="`unit-section-${study_unit.id}`"
        class="my-2"
      ></UnitSection>
    </div>
    <b-button
      v-if="allows_crud"
      size="sm"
      class="secondary-button my-2"
      @click="$bvModal.show(`add-study-unit-modal`)"
      ><b-icon-plus></b-icon-plus>Agregar
      {{ $getVisibleNames("teaching.ramicro", true, "RA Micro") }}</b-button
    > -->
    <div v-if="institution && institution.internal_use_id == 'duoc.cl'">
      <!-- 'LearningExperience' + key_learning_experience + '-' -->
      <!-- @change_matter_evaluations="() => key_matter_program_evaluation++" -->
      <LearningExperience
        v-if="oldMatter"
        :key="+oldMatter.id"
        :matter_id="oldMatter.id"
        :allows_crud="allows_crud && oldMatter && !oldMatter.is_closed"
        :can_update="can_update"
        :can_delete="can_delete"
      >
      </LearningExperience>
    </div>
    <!-- @update_matter_evaluations="() => key_learning_experience++" -->
    <!-- :key="'MatterProgramEvaluation' + key_matter_program_evaluation" -->
    <!-- Duoc mantiene su layout: sin los apartados intermedios (2, 3 y 4) -->
    <MatterProgramDescriptors
      v-if="!isDuoc"
      :page_position="2"
      :matter_id="matter_id"
      :descriptor_titles="egressProfileMatterDescriptor"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_delete="can_delete"
      :can_update="can_update"
      :can_delete_title="canDeleteTitle"
      @titleCreated="titleCreated"
      @deleteTitle="deleteTitle"
    ></MatterProgramDescriptors>
    <MatterProgramEvaluation
      v-if="oldMatter"
      :matter_id="oldMatter.id"
      :allows_crud="allows_crud && oldMatter && !oldMatter.is_closed"
      :can_update="can_update"
      :can_delete="can_delete"
      @created_support_resource="createdSupportResource"
    ></MatterProgramEvaluation>
    <MatterProgramDescriptors
      v-if="!isDuoc"
      :page_position="3"
      :matter_id="matter_id"
      :descriptor_titles="egressProfileMatterDescriptor"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_delete="can_delete"
      :can_update="can_update"
      :can_delete_title="canDeleteTitle"
      @titleCreated="titleCreated"
      @deleteTitle="deleteTitle"
    ></MatterProgramDescriptors>
    <TeachingSupportResourcesComponent
      v-if="oldMatter"
      :key="support_resource_key"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
      :supportResources="support_resources"
    ></TeachingSupportResourcesComponent>
    <BibliographicResourcesComponent
      v-if="oldMatter"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
    ></BibliographicResourcesComponent>
    <ResourcesLearningEnvComponent
      v-if="oldMatter"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_update="can_update"
      :can_delete="can_delete"
    ></ResourcesLearningEnvComponent>
    <MatterProgramDescriptors
      v-if="!isDuoc"
      :page_position="4"
      :matter_id="matter_id"
      :descriptor_titles="egressProfileMatterDescriptor"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_delete="can_delete"
      :can_update="can_update"
      :can_delete_title="canDeleteTitle"
      @titleCreated="titleCreated"
      @deleteTitle="deleteTitle"
    ></MatterProgramDescriptors>
    <TeachingProfileComponent
      v-if="oldMatter"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud && !oldMatter.teacher_profile_locked_view"
      :can_update="can_update"
      :can_delete="can_delete"
    ></TeachingProfileComponent>
    <AssistantProfileComponent
      v-if="oldMatter"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud && !oldMatter.assistant_profile_locked_view"
      :can_update="can_update"
      :can_delete="can_delete"
    ></AssistantProfileComponent>
    <MatterProgramDescriptors
      :page_position="5"
      :matter_id="matter_id"
      :descriptor_titles="egressProfileMatterDescriptor"
      :oldMatter="oldMatter"
      :allows_crud="allows_crud"
      :can_delete="can_delete"
      :can_update="can_update"
      :can_delete_title="canDeleteTitle"
      @titleCreated="titleCreated"
      @deleteTitle="deleteTitle"
    ></MatterProgramDescriptors>
    <!-- modal -->
    <!-- <b-modal
      :id="`add-study-unit-modal`"
      hide-footer
      :title="`Agregar ${$getVisibleNames(
        'teaching.ramicro',
        true,
        'RA Micro'
      )}`"
      size="lg"
    >
      <StudyUnitForm
        v-if="oldMatter"
        :matter_id="oldMatter.id"
        @created="$bvModal.hide('add-study-unit-modal')"
        @close_modal="$bvModal.hide('add-study-unit-modal')"
      ></StudyUnitForm>
    </b-modal> -->
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { isMatterDescriptorTitleAdmin } from "@/utils/utils";
export default {
  name: "OldMatterProgram",
  components: {
    NewMatterPresentation: () =>
      import("./Components/NewMatterPresentation.vue"),
    OldMatterForm: () => import("@/components/mesh/Matrix2/OldMatterForm"),
    MatterProgramDescriptors: () =>
      import("./Components/MatterProgramDescriptors"),
    EvaluationCriteriaMacroComponent: () =>
      import("./Components/EvaluationCriteriaMacroComponent"),
    // UnitSection: () => import("./Components/UnitSection"),
    // StudyUnitForm: () => import("@/components/reusable/StudyUnitForm"),
    MatterProgramEvaluation: () =>
      import("./MatterProgramEvaluation/MatterProgramEvaluation.vue"),
    BibliographicResourcesComponent: () =>
      import("./Components/BibliographicResourcesComponent.vue"),
    ResourcesLearningEnvComponent: () =>
      import("./Components/ResourcesLearningEnvComponent.vue"),
    TeachingSupportResourcesComponent: () =>
      import("./Components/TeachingSupportResourcesComponent"),
    LearningExperience: () => import("./Components/LearningExperience.vue"),
    TeachingProfileComponent: () =>
      import("./Components/TeachingProfileComponent.vue"),
    AssistantProfileComponent: () =>
      import("./Components/AssistantProfileComponent.vue"),
    CompetenceUnits: () => import("./Components/CompetenceUnits"),
    CompetenceUnitForm: () => import("./Components/CompetenceUnitForm"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  props: {
    matter_id: {
      type: Number,
      required: true,
    },
    allows_crud: {
      type: Boolean,
      required: true,
    },
    can_update: {
      type: Boolean,
      defalut: false,
    },
    can_delete: {
      type: Boolean,
      defalut: false,
    },
  },
  data() {
    return {
      // id de título -> si el usuario lo puede borrar (endpoint deletable)
      deletable_titles: {},
      support_resources: [],
      support_resource_key: 0,
      // key_matter_program_evaluation: 0,
      // key_learning_experience: 0,
    };
  },
  computed: {
    ...mapGetters({
      institution: "getInstitution",
      user: "getUser",
      matters: names.MATTERS,
      egress_profile_matter_descriptors:
        names.EGRESS_PROFILE_MATTER_DESCRIPTORS,
      m_middle_descriptors: names.M_MIDDLE_DESCRIPTORS,
      studyUnits: names.STUDY_UNITS,
      competence_units: names.COMPETENCE_UNITS,
    }),
    // Ids de los títulos visibles: si aparece uno sin respuesta del endpoint
    // deletable se vuelve a consultar (string aparte para que el watcher solo
    // dispare cuando cambian los ids).
    titleIdsKey() {
      if (
        !this.matter_id ||
        !this.can_update ||
        !this.can_delete ||
        isMatterDescriptorTitleAdmin(this.user)
      )
        return "";
      return this.egressProfileMatterDescriptor
        .filter((x) => !isNaN(x.id))
        .map((x) => x.id)
        .join(",");
    },
    isDuoc() {
      return !!this.institution && this.institution.internal_use_id == "duoc.cl";
    },
    oldMatter() {
      if (!this.matter_id) return null;
      return this.matters.find((x) => x.id == this.matter_id);
    },
    temp_competence_units() {
      if (!this.oldMatter) return [];
      return this.competence_units.filter((x) => x.matter == this.oldMatter.id);
    },
    matterMiddleDescriptors() {
      if (!this.matter_id) return [];
      return this.m_middle_descriptors.filter(
        (x) => x.matter == this.matter_id
      );
    },
    egressProfileMatterDescriptor() {
      const matter_middle = this.matterMiddleDescriptors.map(
        (x) => x.descriptor
      );
      return this.egress_profile_matter_descriptors.filter(
        (x) => x.is_default || matter_middle.includes(x.id)
      );
    },
    studyUnitsList() {
      if (!this.matter_id) return [];
      return this.studyUnits.filter((x) => x.matter == this.matter_id);
    },
    breadcrumb_items() {
      return [
        { text: this.$t("reusable.breadcrumb.home"), to: "/home" },
        {
          text: this.$getVisibleNames(
            "mesh.egressprofilematter",
            true,
            "Asignaturas"
          ),
          to: `/matter-list`,
        },
        {
          text: this.$getVisibleNames(
            "manual.matter_program",
            false,
            "Programa de la Asignatura"
          ),
          // E52 · Desde acá se baja al Diseño Instruccional de la Asignatura base. Es el
          // diseño que comparten todas las Asignaturas del Perfil que usan sus valores,
          // y hasta ahora la única forma de abrirlo era entrar por una de ellas.
          dropdownOptions: ["showInstructional"],
        },
      ];
    },
  },
  watch: {
    titleIdsKey: {
      handler(ids) {
        if (ids && ids.split(",").some((id) => !(id in this.deletable_titles)))
          this.fetchDeletableTitles();
      },
      immediate: true,
    },
  },
  methods: {
    createdSupportResource(response) {
      this.support_resources.push(response);
      this.support_resource_key += 1;
    },
    fetchSupportResource(matter_id) {
      this.$restful
        .GetAll(`/teaching/support-resource/?matter=${matter_id}`)
        .then((response) => {
          this.support_resources = response;
          this.support_resource_key += 1;
        });
    },
    // Título recién creado por el usuario: se puede borrar sin esperar al backend
    titleCreated(title) {
      this.$set(this.deletable_titles, title.id, true);
    },
    // Borrar un título elimina su contenido en todas las asignaturas que lo usan:
    // superusuario/directivos institucionales siempre; el resto según el backend
    // (no global, sin uso en otro perfil de egreso, o recién creado por el usuario).
    canDeleteTitle(title) {
      if (isMatterDescriptorTitleAdmin(this.user)) return true;
      return this.deletable_titles[title.id] === true;
    },
    fetchDeletableTitles() {
      this.$restful
        .Get(
          `/mesh/egress-profile-matter-descriptor/deletable/?matter=${this.matter_id}`
        )
        .then((response) => {
          this.deletable_titles = { ...this.deletable_titles, ...response };
        });
    },
    deleteTitle(object) {
      this.$store
        .dispatch(names.FETCH_M_MIDDLE_DESCRIPTORS, {
          descriptor_id: object.id,
        })
        .then((response1) => {
          this.$store
            .dispatch(names.FETCH_EPM_MIDDLE_DESCRIPTORS, {
              descriptor_id: object.id,
            })
            .then((response2) => {
              const response = response1.concat(response2);
              this.$swal({
                title: this.$t(
                  "matterProgram.matterProgramView.deleteTitleConfirm"
                ),
                text: this.$t(
                  "matterProgram.matterProgramView.deleteTitleWarning"
                ),
                type: "warning",
                footer: `<ul class="w-100" style="max-height: 300px; overflow-y: auto;">
            <li>${this.$t("reusable.common.title")}: ${object.title}</li>
            ${response
              .map(
                (item) =>
                  `<li>${this.$t(
                    "matterProgram.matterProgramView.content"
                  )}: ${this.$htmlToPlainText(item.description)}</li>`
              )
              .join("")}
              </ul>`,
                showCancelButton: true,
                cancelButtonText: this.$t("reusable.common.cancel"),
              }).then((result) => {
                if (result.value) {
                  this.$store.dispatch(
                    names.DELETE_EGRESS_PROFILE_MATTER_DESCRIPTORS,
                    object.id
                  );
                }
              });
            });
        });
    },
  },
  mounted() {
    // Guardar matter_id en breadcrumb_context de localStorage
    if (this.matter_id) {
      localStorage.removeItem("breadcrumb");
      const context = JSON.parse(localStorage.getItem("breadcrumb") || "{}");
      context.matter_id = this.matter_id;
      localStorage.setItem("breadcrumb", JSON.stringify(context));
    }
  },
  created() {
    this.$store.dispatch(names.FETCH_M_MIDDLE_DESCRIPTORS, {
      matter_id: this.matter_id,
    });
    this.$store.dispatch(
      names.FETCH_EVALUATION_CRITERIAS_MACROS,
      this.matter_id
    );
    this.$store.dispatch(names.FETCH_RA_MACROS, {
      matter_id: this.matter_id,
    });
    this.$store.dispatch(names.FETCH_EGRESS_PROFILE_MATTER_DESCRIPTORS, {
      matter_id: this.matter_id,
    });
    if (this.institution && this.institution.show_competence_unit)
      this.$store.dispatch(names.FETCH_COMPETENCE_UNITS, {
        matter__id: this.matter_id,
      });
    // FETCH_EVALUATION_CRITERIAS (indicadores de logro), FETCH_CONTENTS_BY_STUDY_UNITS
    // (contenidos) y FETCH_METHODOLOGICAL_STRATEGIES se piden aquí, una sola vez para
    // todas las unidades de estudio. UnitSection.vue ya no los pide por su cuenta (se
    // centralizaron), por lo que sin estos dispatch los contenidos/indicadores salen vacíos.
    this.$store.dispatch(names.FETCH_METHODOLOGICAL_STRATEGIES);
    this.$store.dispatch(names.FETCH_EVALUATION_CRITERIAS, {
      matter_id: this.matter_id,
    });
    this.$store
      .dispatch(names.FETCH_STUDY_UNITS, this.matter_id)
      .then((study_units) => {
        this.$store.dispatch(
          names.FETCH_CONTENTS_BY_STUDY_UNITS,
          study_units.map((study_unit) => study_unit.id)
        );
      });
    this.$store.dispatch(names.FETCH_STUDY_ENVIRONMENTS);
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$store.dispatch(names.FETCH_MATTER_TIME_ALLOCATIONS, {
      matter_id: this.matter_id,
    });
    this.fetchSupportResource(this.matter_id);
    this.$store.dispatch(names.FETCH_SUPPORT_RESOURCE_TYPES);
    this.$store.dispatch(names.FETCH_TAXONOMIES);
  },
};
</script>

<style scoped>
</style>
